export type Config = {
  apiUrl: string
  basicAuthUsername: string
  basicAuthPassword: string
  env: string
  firebaseApiKey: string
  firebaseAuthDomain: string
  firebaseProjectId: string
  firebaseAppId?: string
  firebaseMeasurementId?: string
  firebaseMessagingSenderId?: string
  firebaseStorageBucket?: string
}

export const createConfig = (): Config => {
  return {
    apiUrl: import.meta.env.VITE_API_URL as string,
    basicAuthUsername: import.meta.env.VITE_BASIC_AUTH_USERNAME as string,
    basicAuthPassword: import.meta.env.VITE_BASIC_AUTH_PASSWORD as string,
    env: import.meta.env.VITE_ENV as string,
    firebaseApiKey: import.meta.env.VITE_FIREBASE_API_KEY as string,
    firebaseAuthDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string,
    firebaseProjectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string,
    firebaseAppId: import.meta.env.VITE_FIREBASE_APP_ID as string | undefined,
    firebaseMeasurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID as string | undefined,
    firebaseMessagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as string | undefined,
    firebaseStorageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET as string | undefined,
  }
}
